import get from 'lodash.get';
import getPage from './page';

const getUsedBlocks = (rootState, pageId) => {
  const targetPage = getPage(rootState, pageId);

  return get(targetPage, 'usedBlocks', []);
};

export default getUsedBlocks;
